import styled from 'styled-components';

import Icon from 'components/Icon';

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 40px 40px 26px;
	border-bottom: 0px solid #F2F2F2;
	position: relative;

	&:before {
		content: "";
		position: absolute;
		top: 100%
		left: 0px;
		width: 100%;
		height: 16px;
		z-index: 1;
		background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);
	}
`;

const Name = styled.div`
	display: flex;
	align-items: center;

	h3 {
		margin: 0 0 0 16px;
		color: ${props => props.theme.main};
	}
`;

const TitleIcon = styled(Icon)`
	svg {
		fill: ${props => props.theme.main};
	}
`;

export {
	Container,
	Name,
	TitleIcon,
}
